/* global axios */
import ApiClient from '../ApiClient';

// Shared whole-floor plan images (one per Tower+Floor) — see
// Nexceo::FloorPlan. Distinct from a unit's own individual floor plan
// image (dashboard/api/nexceo/unitInventory.js#uploadFloorPlanImage).
class NexceoFloorPlansAPI extends ApiClient {
  constructor() {
    super('nexceo/projects', { accountScoped: true });
  }

  list(projectId, tower = null) {
    return axios.get(`${this.url}/${projectId}/floor_plans`, {
      params: tower ? { tower } : {},
    });
  }

  // Upsert-by-(tower, floor) — re-posting the same tower+floor replaces
  // the existing image (see FloorPlansController#create).
  upload(projectId, { tower, floor, image }) {
    const formData = new FormData();
    if (tower) formData.append('tower', tower);
    formData.append('floor', floor);
    formData.append('image', image);
    return axios.post(`${this.url}/${projectId}/floor_plans`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  destroy(projectId, floorPlanId) {
    return axios.delete(`${this.url}/${projectId}/floor_plans/${floorPlanId}`);
  }
}

export default new NexceoFloorPlansAPI();
